import { render, staticRenderFns } from "./YXAgreement.vue?vue&type=template&id=65c0893e&scoped=true&"
var script = {}
import style0 from "./YXAgreement.vue?vue&type=style&index=0&id=65c0893e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0893e",
  null
  
)

export default component.exports